import { FormatTypeCopySink } from './format-type.copysink';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { JsonDataset } from 'shell-models-lib';

@Metamodel.model({
    name: 'JsonSink',
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(JsonDataset) }
})
export class JsonSink extends FormatTypeCopySink {
    public static readonly MODEL: IModel;
}
